'use client';
import React from 'react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { useRouter } from 'next/navigation';
import { signOut } from '@/auth';
import SignoutButton from '@/components/SignoutButton';
import Link from 'next/link';
import LogoutButton from '@/components/LogoutButton';

function UserProfile({ user }) {

  // TODO: Remove "sign out" button and place in header with "sign in" button
  return (
    <DropdownMenu data-align="start">
      <DropdownMenuTrigger className="focus:outline-none" asChild>
        <Avatar className="cursor-pointer animate__animated animate__fadeIn">
          <AvatarImage src={user.image} />
          <AvatarFallback>{user.name.substring(0,1)}</AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="inverse-bg-black" align="end">
        <DropdownMenuLabel>{user.name}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem  className="cursor-pointer p-0">
          <LogoutButton />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
//<Link href="/auth/signout">Sign out</Link>
export default UserProfile;
